/** @jsx jsx */
import { Grow } from '@material-ui/core';
import { jsx } from '@emotion/core';
import ErrorIcon from '@material-ui/icons/Error';
import React from 'react';

import styles from './styles';
import { composeStyles } from 'features/Theme';

type Severity = 'success' | 'error' | 'info';
interface AlertProps {
  open: boolean;
  severity?: Severity;
  className?: string;
}

const severityAlt: { [k in Severity]: string } = {
  success: 'Success',
  error: 'Error',
  info: 'Info',
};

export const AlertBar: React.FC<AlertProps> = props => {
  const { open, severity, className } = props;

  return (
    <Grow in={open}>
      <aside
        css={composeStyles([
          styles.container,
          severity && styles[severity],
          open && styles.open,
        ])}
        className={className}
        aria-label="Alerts"
      >
        <ErrorIcon
          css={styles.icon}
          titleAccess={severity ? severityAlt[severity] : undefined}
          aria-label="Alert Error Icon"
        />
        <div css={styles.body}>{props.children}</div>
      </aside>
    </Grow>
  );
};
